export const MAX_ORGANIZATION_ID = 'x0NIn8hih';
